const notification = props => {


    if (props.success) {
        return (<p className="successMessage"> {props.message}</p>)
    } else {
        return (<p className="errorMessage"> {props.message}</p>)
    }
}

export default notification;
